import {
  QUICK_ORDER_CHANGE_QUANTITY,
  QUICK_ORDER_NEW_ROW_ACTIVE,
  QUICK_ORDER_REMOVE,
  QUICK_ORDER_SET_NEW_ROW_VALUE,
  QUICK_ORDER_UPDATE,
} from '../constants';

export const quickOrder = (
  state = {
    orderRows: [],
    formattedOrderTotal: '',
    newRowActive: true,
    newRowValue: '',
    errors: [],
  },
  action
) => {
  switch (action.type) {
    case QUICK_ORDER_NEW_ROW_ACTIVE:
    case QUICK_ORDER_SET_NEW_ROW_VALUE:
    case QUICK_ORDER_REMOVE:
    case QUICK_ORDER_CHANGE_QUANTITY:
    case QUICK_ORDER_UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
